$(document).on('turbolinks:load', function() {
  $('.notifications-page').on('change', '#select_all', function() {
    if($(this).is(':checked')) {
      $('.notifications input[type="checkbox"]').prop('checked', true);
      $(this).parent().next().text('All Selected');
      $(this).closest('form').find('.bulk-delete').show();
      $(this).closest('.bulk-actions__select-all').addClass('bulk-actions__select-all--selected');
    } else {
      $('.notifications input[type="checkbox"]').prop('checked', false);
      $(this).parent().next().text('Select All');
      $(this).closest('form').find('.bulk-delete').hide();
      $(this).closest('.bulk-actions__select-all').removeClass('bulk-actions__select-all--selected');
    }
  });
  $('.notifications-page').on('change', '.notifications input[type="checkbox"]', function() {
    if($('.notifications input[type="checkbox"]:checked').length) {
      $(this).closest('form').find('.bulk-delete').show();
    } else {
      $(this).closest('form').find('.bulk-delete').hide();
    }
  });
  $('.notifications-page .bulk-actions__delete').on('click', function(e) {
    e.preventDefault();
    $(this).closest('form').submit();
  });
});